export default __webpack_public_path__ + "static/media/slider2.d09eeeb6.png";